import * as React from "react";

const IconTextLinkArrowLeftHover: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 9"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path fill="#298CF0" d="M10.479 4.5c0 .415-.314.75-.73.75H2.563l2.47 2.47A.75.75 0 113.97 8.78L.22 5.03a.75.75 0 010-1.06L3.97.22a.75.75 0 111.06 1.06L2.562 3.75H9.75c.415 0 .729.335.729.75z"/></svg>;
};

export default React.memo(IconTextLinkArrowLeftHover);
